import { Col, Tile } from '@op/opds.opux';
import { Message, useMessageGetter } from '@messageformat/react';
import { IO_ADD_INSURANCE_TARGET } from '../../constants/actionTypes';
import { DEFAULT_LOCALE } from '../../constants/common';
import { useInsuranceOffer } from '../../hooks';

const AddNewInsurance = ({ tile, ibRef, name }) => {
  const { state, createOrDeleteInsurance } = useInsuranceOffer();
  const getMessage = useMessageGetter();
  const getDefaultMessage = useMessageGetter([], { locale: DEFAULT_LOCALE });

  const addInsuranceTarget = (
    insuranceId,
    component,
    validator,
    icon,
    title
  ) => {
    const { insuranceSelectionIndex } = state;
    createOrDeleteInsurance({
      type: IO_ADD_INSURANCE_TARGET,
      insuranceId,
      insuranceSelectionIndex,
      component,
      validator,
      icon,
      caption: getMessage(title),
      defaultCaption: getDefaultMessage(title),
      sendInsurance: true
    });
  };

  return (
    <Col xs={6} lg={3}>
      <Tile
        id={name}
        wrapContent={false}
        interactiveArea={'tile'}
        onClick={() => {
          addInsuranceTarget(
            tile.insuranceId,
            tile.component,
            tile.validator,
            tile.icon,
            `uiText.${tile.insuranceId}`
          );
          ibRef.current.close();
        }}
      >
        <tile.icon
          viewBox={'-15 -15 100 100'}
          className={'RS-insurance-tile'}
        />
        <span id={`label-${name}`} className={`RS-add-new-target-name`}>
          <p>
            <Message id={`uiText.${tile.insuranceId}`} />
          </p>
        </span>
      </Tile>
    </Col>
  );
};

export default AddNewInsurance;
